// extracted by mini-css-extract-plugin
export var growableInput = "_68-0";
export var tagContainer = "_68-2";
export var textInput = "_68-1";